import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { getAuthProviderLoginUrl } from '../utils/auth_url';
import establishBackground from '../assets/images/establish_background.webp';

function EstablishPage() {
  const handleLogin = () => {
    const authProviderUrl = getAuthProviderLoginUrl();
    window.location.href = authProviderUrl;
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url(${establishBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 4,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          zIndex: 1
        }
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 2, maxWidth: 'sm', width: '100%', px: 2 }}>
        <Typography variant="h2" component="h1" gutterBottom sx={{ color: 'white' }}>
          DevSight
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'white' }}>
          Engineering & Product
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={handleLogin}
          sx={{ mt: 4 }}
        >
          Get Started
        </Button>
      </Box>
    </Box>
  );
}

export default EstablishPage; 